import button from './dojo/button.m.css';
import checkbox from './dojo/checkbox.m.css';
import label from './dojo/label.m.css';
import icon from './dojo/icon.m.css';
import tooltip from './dojo/tooltip.m.css';
import radio from './dojo/radio.m.css';
import tabcontainer from './base-widgets/tab-container.m.css';
import accordion2 from './base-widgets/accordion2.m.css';
import slidingpane from './base-widgets/sliding-pane.m.css';
import glossary from './glossary/glossary.m.css';
import audio from './audio/audio.m.css';
import video from './video/video.m.css';
import backview from './backview/backview.m.css';
import expanded from './card/expanded.m.css';
import tgf from './card/tgf.m.css';
import activity from './learning-activity/activity.m.css';
import heading from './lcc-app/heading.m.css';
import content from './lcc-app/content.m.css';
import splash from './lcc-app/splash.m.css';
import footer from './lcc-app/footer.m.css';
import document from './lcc-rcs/document.m.css';
import topicpage from './book-widgets/topicpage.m.css';
import topicgroup from './book-widgets/topicgroup.m.css';
import topicaccordion from './book-widgets/topicaccordion.m.css';
import statusicon from './book-widgets/status-icon.m.css';
import prepost from './prepost-viz/prepost-viz.m.css';
import progress from './prepost-viz/progress-viz.m.css';
import toc from './table-of-contents/toc.m.css';
import trigger from './table-of-contents/trigger.m.css';
import drawer from './table-of-contents/drawer.m.css';
import discussion from './quiz-widgets/discussion.m.css';
import flashcard from './quiz-widgets/flashcard.m.css';
import mcquestion from './quiz-widgets/mcquestion.m.css';
import pretestreview from './quiz-widgets/pretest-review.m.css';
import prometricreview from './quiz-widgets/prometric-review.m.css';
import prometric from './quiz-widgets/prometric.m.css';
import questionfeedback from './quiz-widgets/questionfeedback.m.css';
import singlestep from './quiz-widgets/singlestep.m.css';
import quizfolder from './quiz-widgets/quizfolder.m.css';
import welcomeview from './landing-page/welcome-view.m.css';
import landingpagegeneral from './landing-page/general.m.css';
import contentorder from './explore-view/content-order.m.css';
import carouselview from './explore-view/carousel-view.m.css';
import chooser from './explore-view/chooser.m.css';
import navcard from './explore-view/nav-card.m.css';
import cscpVariant from './variants/cscp.m.css';
import cltdVariant from './variants/cltd.m.css';
import cpimVariant from './variants/cpim.m.css';
import ctscVariant from './variants/ctsc.m.css';
import ascmpreviewVariant from './variants/ascmpreview.m.css';
import ascm2024demoVariant from './variants/ascm2024demo.m.css';
import cscp2024Variant from './variants/cscp2024.m.css';
import cscp2024ssVariant from './variants/cscp2024ss.m.css';
import cltd2024Variant from './variants/cltd2024.m.css';
import cltd2024ssVariant from './variants/cltd2024ss.m.css';
import cpim2024Variant from './variants/cpim2024.m.css';
import cpim2024ssVariant from './variants/cpim2024ss.m.css';
import ctsc2024Variant from './variants/ctsc2024.m.css';
import ctsc2024ssVariant from './variants/ctsc2024ss.m.css';
export default {
    theme: {
        '@dojo/widgets/button': button,
        '@dojo/widgets/checkbox': checkbox,
        '@dojo/widgets/label': label,
        '@dojo/widgets/icon': icon,
        '@dojo/widgets/tooltip': tooltip,
        '@dojo/widgets/radio': radio,
        'glossary/glossary': glossary,
        'backview/backview': backview,
        'card/expanded': expanded,
        'card/tgf': tgf,
        'learning-activity/activity': activity,
        'audio/audio': audio,
        'video/video': video,
        'lcc-app/heading': heading,
        'lcc-app/content': content,
        'lcc-app/splash': splash,
        'lcc-app/footer': footer,
        'lcc-rcs/document': document,
        'base-widgets/tab-container': tabcontainer,
        'base-widgets/accordion2': accordion2,
        'base-widgets/sliding-pane': slidingpane,
        'book-widgets/topicpage': topicpage,
        'book-widgets/topicgroup': topicgroup,
        'book-widgets/topicaccordion': topicaccordion,
        'book-widgets/status-icon': statusicon,
        'prepost-viz/prepost-viz': prepost,
        'prepost-viz/progress-viz': progress,
        'table-of-contents/toc': toc,
        'table-of-contents/trigger': trigger,
        'table-of-contents/drawer': drawer,
        'quiz-widgets/discussion': discussion,
        'quiz-widgets/flashcard': flashcard,
        'quiz-widgets/mcquestion': mcquestion,
        'quiz-widgets/pretest-review': pretestreview,
        'quiz-widgets/prometric-review': prometricreview,
        'quiz-widgets/prometric': prometric,
        'quiz-widgets/questionfeedback': questionfeedback,
        'quiz-widgets/singlestep': singlestep,
        'quiz-widgets/quizfolder': quizfolder,
        'landing-page/welcome-view': welcomeview,
        'landing-page/general': landingpagegeneral,
        'explore-view/content-order': contentorder,
        'explore-view/carousel-view': carouselview,
        'explore-view/chooser': chooser,
        'explore-view/nav-card': navcard
    },
    variants: {
        cscp: cscpVariant,
        cltd: cltdVariant,
        cpim: cpimVariant,
        ctsc: ctscVariant,
        ascmpreview: ascmpreviewVariant,
        ascm2024demo: ascm2024demoVariant,
        cscp2024: cscp2024Variant,
        cscp2024ss: cscp2024ssVariant,
        cltd2024: cltd2024Variant,
        cltd2024ss: cltd2024ssVariant,
        cpim2024: cpim2024Variant,
        cpim2024ss: cpim2024ssVariant,
        ctsc2024: ctsc2024Variant,
        ctsc2024ss: ctsc2024ssVariant
    }
};
